import { gql } from '@apollo/client';

export const CREATE_REPORT_FILE = gql`
  mutation CreateReportsFile($input: ReportFile) {
    createReportsFile(input: $input) {
      message
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation CreateReports($input: Reports) {
    createReports(input: $input) {
      message
    }
  }
`;

export const UPDATE_REPORT = gql`
  mutation UpdateReports($id: ID!, $input: Reports) {
    updateReports(id: $id, input: $input) {
      message
    }
  }
`;
